import { Divider, Typography } from 'antd'
import React from 'react'
import Dashboard from '../../../components/Wash/Dashboard/Dashboard';

const WashDashboardPage = ({ userData }) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography.Title
          level={5}
          style={{
            margin: 0,
          }}
        >
          Dashboard
        </Typography.Title>
      </div>
      <Divider style={{ marginTop: 8 }} />
      <Dashboard userData={userData} />

    </>
  )
};

export default WashDashboardPage